import React from 'react'

import { ProductSummaryOrder } from '@thg-commerce/enterprise-pages/src/Product/theme'
import {
  css,
  margin,
  mq,
  spacing,
  styled,
  Text,
} from '@thg-commerce/enterprise-theme'
import { ProductReview, SafeHtml } from '@thg-commerce/gravity-elements'
import { Margin } from '@thg-commerce/gravity-theme'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

export const DetailsContainer = styled.div<{ margin?: Margin }>`
  margin: ${(props) =>
    props.margin
      ? margin(props.margin)
      : margin({ top: 0, left: 0, bottom: 2, right: 0 })};
  display: flex;
  flex-direction: column;
`

export const Title = styled.h1<{
  textStyle?: TextStyling
  order?: ProductSummaryOrder
  styleOverride?: React.CSSProperties
}>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'large1',
      props.textStyle?.style || 'alternate',
    )};
  order: ${(props) => props.order || ProductSummaryOrder.ONE};
  padding: ${spacing(0.5)} 0 ${spacing(1)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(1)} 0;
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'xs')} {
    ${css`
      ${(props) => props.styleOverride}
    `}
`

export const PowerReviewReviewSnippetContainer = styled.div<{
  displayStyle?: string
}>`
  #pr-reviews-snippet {
    min-height: 35px;
  }

  .p-w-r {
    .pr-no-reviews {
      .pr-snippet-stars-container {
        display: ${(props) => props.displayStyle ?? 'none'};
      }
    }
  }
`

export const SubTitle = styled(SafeHtml)<{
  order?: ProductSummaryOrder
  textStyle?: TextStyling
}>`
  ${(props) =>
    !props.textStyle
      ? Text('medium1', 'default')
      : css`
          ${Text(props.textStyle.entry, props.textStyle.style)}
        `}
  order: ${(props) => props.order || ProductSummaryOrder.THREE};
`

export const ErrorText = styled(SafeHtml)`
  ${Text('medium1', 'default')};
  margin-bottom: ${spacing(2)};
`

export const ReviewContainer = styled.div`
  display: flex;
  align-content: center;
  height: 16px;
`

export const TagsRendererWrapper = styled.div<{ order?: ProductSummaryOrder }>`
  order: ${(props) => props.order || ProductSummaryOrder.TWO};
`

export const PriceContainer = styled.div<{ reduceBottomMargin?: boolean }>`
  display: flex;
  align-content: center;
  margin: ${(props) =>
    props.reduceBottomMargin
      ? `${spacing(2)} 0 ${spacing(1)} 0}`
      : `${spacing(2)} 0;`};
`

export const ProofOfImpactIconWrapper = styled.div<{ order?: number }>`
  order: ${(props) => props.order || ProductSummaryOrder.SIX};
`

export const StyledProductReview = styled(ProductReview)`
  margin-bottom: ${spacing(2.5)};
`
